.peep-last-contacted-times {
    float: left;
}

.peep-last-contacted-times p {
    font-size: 13px;
    line-height: 17px;
    margin: 0 0 4px 0;
}
